import { render, staticRenderFns } from "./pro-sale-code-list.vue?vue&type=template&id=5824afd6"
import script from "./pro-sale-code-list.vue?vue&type=script&lang=js"
export * from "./pro-sale-code-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports